import { Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import TableComponent from 'UiKit/table-component';
import { TextBold, TextMedium, TextRegular } from 'UiKit/typography';

import { useReportAttendanceHostDetailState } from 'View/report-attendance-host-detail/state';
import tableList from './const';

import styles from './styles.module.css';

const LivestreamDetailModal = () => {
  const { t } = useTranslation('report-attendance-host-detail');
  const { state, updateState } = useReportAttendanceHostDetailState();

  const { livestreamData } = state;

  const shouldNotShow = (value) => value?.startLive?.status !== 'Belum Livestream' && value?.startLive?.status !== 'Tidak Live' && !!value?.startLive;

  const handleCloseModal = () => {
    updateState({
      isOpenModalDetailLivestream: false,
      livestreamData: null,
      ...(state.imagePreviewPreviousModal ? { [state.imagePreviewPreviousModal]: true } : {}),
      imagePreviewPreviousModal: null,
    });
  };

  const handleOpenPreview = (images) => {
    updateState({
      isOpenImagePreview: true,
      selectedImagePreview: images,
      isOpenModalDetailLivestream: false,
      imagePreviewPreviousModal: 'isOpenModalDetailLivestream',
    });
  };

  const livestreams = Object.fromEntries(Object.entries(livestreamData || {}).filter(([key, value]) => key.startsWith('session_') && shouldNotShow(value)));

  return (
    <Modal isOpen={state?.isOpenModalDetailLivestream} onClose={handleCloseModal} isCentered>
      <ModalOverlay />
      <ModalContent minWidth={'983px'} maxHeight={'660px'}>
        <ModalHeader>
          <TextBold className={styles['modal__text--title']}>{t('columnLivestreamDetail.title')}</TextBold>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody className={styles['modal__section--content']}>
          <Box className={styles['modal__section--livestream']}>
            <Box className={styles['modal__section--livestream-info']}>
              <Box className={styles['modal__row--livestream']}>
                <Box className={styles['modal__value']}>
                  <TextRegular className={styles['modal__text--label']}>{t('columnLivestreamDetail.hostName')}</TextRegular>
                  <TextMedium className={styles['modal__text--value']}>{livestreamData?.hostName || '-'}</TextMedium>
                </Box>
                <Box className={styles['modal__value']}>
                  <TextRegular className={styles['modal__text--label']}>{t('columnLivestreamDetail.shift')}</TextRegular>
                  <TextMedium className={styles['modal__text--value']}>{moment(livestreamData?.shiftDate).format('DD MMMM YYYY') || '-'}</TextMedium>
                </Box>
                <Box className={styles['modal__value']}>
                  <TextRegular className={styles['modal__text--label']}>{t('columnLivestreamDetail.totalLivestream')}</TextRegular>
                  <TextMedium className={styles['modal__text--value']}>{Object.keys(livestreams).length || 0}</TextMedium>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className={styles['modal__section--livestream-list']}>
            <TableComponent
              columns={tableList(handleOpenPreview, t)}
              dataSource={Object.values(livestreams) || []}
              isDataExist={Object.values(livestreams).length > 0}
              rowHeight="fit-content"
              paddingBodyBox="20px 12px"
              maxTableBodyHeight="384px"
              verticalAlignBody="top"
            />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default LivestreamDetailModal;
